import { render, staticRenderFns } from "./BackofficeAnexo.vue?vue&type=template&id=124efe37&scoped=true"
import script from "./BackofficeAnexo.vue?vue&type=script&lang=ts"
export * from "./BackofficeAnexo.vue?vue&type=script&lang=ts"
import style0 from "./BackofficeAnexo.vue?vue&type=style&index=0&id=124efe37&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "124efe37",
  null
  
)

export default component.exports